import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MtIconsModule } from 'projects/mailtastic-icons-library/src/lib/mt-icons/mt-icons.module';
import { NgbDropdownModule, NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

// Components
import { CogsigTopInfoBannerComponent } from './cogsig-top-info-banner/cogsig-top-info-banner.component';
import { MtSvgComponent } from '@shared/components/atoms/svg/mt-svg.component';
import { NavigationHeaderComponent } from './navigation-header/navigation-header.component';
import { NavigationHeaderEmployeeSubmenuComponent } from './submenu-employee/navigation-header-employee-submenu.component';
import { NavigationHeaderIntegrationSubmenuComponent } from './submenu-integrations/navigation-header-integration-submenu.component';
import { NavigationSidebarMainMenusComponent } from './menu/navigation-sidebar-main-menus.component';
import { NavigationHeaderMarketingSubmenuComponent } from './submenu-marketing/navigation-header-marketing-submenu.component';
import { NavigationSidebarMenuHeaderComponent } from './menu-header/navigation-sidebar-menu-header.component';
import { NavigationHeaderSettingsSubmenuComponent } from './submenu-settings/navigation-header-settings-submenu.component';
import { NavigationSidebarSettingsTooltipComponent } from './settings/navigation-sidebar-settings-tooltip.component';
import { NavigationHeaderSignatureSubmenuComponent } from './submenu-signature/navigation-header-signature-submenu.component';
import { NavigationSidebarSubmenuHeaderComponent } from './submenu-header/navigation-sidebar-submenu-header.component';
import { TopInfoBannerComponent } from './top-info-banner/top-info-banner.component';
import { TopInfoBannerSuperAdminComponent } from './top-info-banner-super-admin/top-info-banner-super-admin.component';

// Modules
import { DashboardRoutingModule } from '@modules/dashboard/dashboard-routing.module';

// Directives
import { ClickOutsideDirective } from '@modules/root/directives/click-outside/click-outside.directive';
import { ClaimAuthorizationDirective } from '@shared/directives/claim-authorization/claim-authorization.directive';

// Pipes
import { DisplayMenuByPlanPipe } from './pipes/display-menu-by-plan/display-menu-by-plan.pipe';
import { HeaderAdjustmentPipe } from 'src/app/modules/root/pipes/header-adjustment/header-adjustment.pipe';
import { IsMenuShownPipe } from 'src/app/modules/root/pipes/is-menu-shown/is-menu-shown.pipe';
import { ShortNamePipe } from './pipes/short-name/short-name.pipe';
import { SubmenuInactivePipe } from 'src/app/modules/root/pipes/submenu-inactive/submenu-inactive.pipe';
import { TextTruncatePipe } from '@shared/pipes/text-truncate/text-truncate.pipe';
import { TopAreaShownPipe } from './pipes/top-area-shown/top-area-shown.pipe';

// Services
import { IntegrationsService } from '@modules/integrations/services/integrations.service';
import { SimpleAuthService } from '@modules/auth/services/simple-auth.service';
import { ButtonComponent } from '@shared/components/atoms/buttons/button/button.component';
import { MultiRouterLinkActiveDirective } from '@modules/root/directives/link-active/multi-router-link-active.directive';

@NgModule({
  declarations: [
    ClickOutsideDirective,
    CogsigTopInfoBannerComponent,
    DisplayMenuByPlanPipe,
    HeaderAdjustmentPipe,
    IsMenuShownPipe,
    NavigationHeaderComponent,
    NavigationHeaderIntegrationSubmenuComponent,
    NavigationSidebarMainMenusComponent,
    NavigationSidebarMenuHeaderComponent,
    NavigationHeaderSettingsSubmenuComponent,
    NavigationSidebarSettingsTooltipComponent,
    NavigationHeaderSignatureSubmenuComponent,
    NavigationSidebarSubmenuHeaderComponent,
    ShortNamePipe,
    TopAreaShownPipe,
    TopInfoBannerComponent,
    TopInfoBannerSuperAdminComponent
  ],
  imports: [
    ButtonComponent,
    ClaimAuthorizationDirective,
    CommonModule,
    DashboardRoutingModule,
    FormsModule,
    MtIconsModule,
    MtSvgComponent,
    MultiRouterLinkActiveDirective,
    NavigationHeaderEmployeeSubmenuComponent,
    NavigationHeaderMarketingSubmenuComponent,
    NgbDropdownModule,
    NgbModule,
    NgbTooltip,
    ReactiveFormsModule,
    RouterModule,
    SubmenuInactivePipe,
    TextTruncatePipe,
    TranslocoModule
  ],
  exports: [NavigationHeaderComponent],
  providers: [IntegrationsService, SimpleAuthService]
})
export class MtNavigationHeaderModule {}
